var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true }
        }
      ]
    },
    [
      _c(
        "el-header",
        { attrs: { height: "90px" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative", top: "25px" } },
                  [
                    _c("img", {
                      attrs: { src: require("../assets/images/logo.svg") }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          position: "absolute",
                          "z-index": "1",
                          left: "80px",
                          top: "30px"
                        }
                      },
                      [
                        _vm._v(
                          "The Go-To Choice\n                        for Cloud-to-Cloud Data"
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "right",
                    "align-items": "center",
                    "margin-top": "25px"
                  },
                  attrs: { span: 18 }
                },
                _vm._l(_vm.clouds, function(cloud) {
                  return _c(
                    "el-button",
                    {
                      key: cloud,
                      on: {
                        click: function($event) {
                          return _vm.readyAddDrive(cloud)
                        }
                      }
                    },
                    [
                      _c("div", {
                        class: "drive-icon-" + cloud,
                        staticStyle: {
                          width: "24px",
                          height: "24px",
                          display: "inline-block",
                          "background-size": "24px",
                          "vertical-align": "middle"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "vertical-align": "middle",
                            display: "inline-block",
                            height: "24px",
                            "line-height": "24px"
                          }
                        },
                        [_vm._v(_vm._s(cloud))]
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            { attrs: { width: "260px" } },
            _vm._l(_vm.drives, function(drive) {
              return _c(
                "div",
                {
                  key: drive.id,
                  staticClass: "drive-item",
                  class: _vm.curDriveId == drive.id ? "selected" : "",
                  on: {
                    click: function($event) {
                      return _vm.openDrive(drive.id)
                    }
                  }
                },
                [
                  _c("div", {
                    class: "drive-icon-" + drive.type,
                    staticStyle: {
                      width: "24px",
                      height: "24px",
                      display: "inline-block",
                      "background-size": "24px",
                      "vertical-align": "middle"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "vertical-align": "middle" } }, [
                    _vm._v(_vm._s(drive.name))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "light", placement: "right" } },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.infoDrive(drive.id)
                                }
                              }
                            },
                            [_vm._v("Detail")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.deleteDrive(drive.id)
                                }
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-more" })
                    ],
                    2
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("el-main", [
            _c(
              "div",
              { staticClass: "main-left" },
              [
                _c("div", { staticClass: "create-task" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "110px" },
                                  attrs: { placeholder: "Type" },
                                  model: {
                                    value: _vm.taskParam.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.taskParam, "type", $$v)
                                    },
                                    expression: "taskParam.type"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "Transfer", value: "tran" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "Sync", value: "sync" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "Backup", value: "backup" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Name" },
                                model: {
                                  value: _vm.taskParam.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.taskParam, "name", $$v)
                                  },
                                  expression: "taskParam.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "List" },
                                model: {
                                  value:
                                    _vm.taskParam.param.options.threadCountList,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.taskParam.param.options,
                                      "threadCountList",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "taskParam.param.options.threadCountList"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 5 } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Run" },
                                model: {
                                  value:
                                    _vm.taskParam.param.options.threadCount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.taskParam.param.options,
                                      "threadCount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "taskParam.param.options.threadCount"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 4 } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  on: { click: _vm.createTask }
                                },
                                [_vm._v("Create Task")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { margin: "10px 0px" } },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.selectTaskNodeFrom } },
                        [_vm._v("Set From")]
                      ),
                      _vm._v(" "),
                      _vm.taskParam.fdid
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getDrive(_vm.taskParam.fdid).name +
                                  _vm.getNodePath(_vm.taskParam.param.from)
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("el-button", { on: { click: _vm.selectTaskNodeTo } }, [
                        _vm._v("Set To")
                      ]),
                      _vm._v(" "),
                      _vm.taskParam.tdid
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getDrive(_vm.taskParam.tdid).name +
                                  _vm.getNodePath(_vm.taskParam.param.to)
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.curDriveId
                  ? _c(
                      "el-breadcrumb",
                      {
                        staticClass: "folder-nav",
                        attrs: { "separator-class": "el-icon-arrow-right" }
                      },
                      [
                        _c(
                          "el-breadcrumb-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "folder-nav-span",
                                on: {
                                  click: function($event) {
                                    return _vm.openFolder(
                                      _vm.curDriveId,
                                      null,
                                      null
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getDrive(_vm.curDriveId).name)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.curStart
                              ? _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.openFolder(
                                          _vm.curDriveId,
                                          _vm.curNode,
                                          _vm.curStart
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Next")]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.getNodeArr(_vm.curNode), function(node) {
                          return _c(
                            "el-breadcrumb-item",
                            { key: node.id },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "folder-nav-span",
                                  on: {
                                    click: function($event) {
                                      return _vm.openFolder(
                                        _vm.curDriveId,
                                        node,
                                        null
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(node.name))]
                              ),
                              _vm._v(" "),
                              _vm.curStart
                                ? _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.openFolder(
                                            _vm.curDriveId,
                                            _vm.curNode,
                                            _vm.curStart
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Next")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "filesTable",
                    attrs: { data: _vm.curResult, "highlight-current-row": "" },
                    on: { "current-change": _vm.handleCurrentChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "Name", "show-overflow-tooltip": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.dir
                                ? _c("i", { staticClass: "el-icon-folder" })
                                : _c("i", { staticClass: "el-icon-document" }),
                              _vm._v(" "),
                              scope.row.dir
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "item-folder",
                                      on: {
                                        click: function($event) {
                                          return _vm.openFolder(
                                            _vm.curDriveId,
                                            scope.row,
                                            null
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                : _c("span", [_vm._v(_vm._s(scope.row.name))])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Size", width: "100px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.formatBytes(scope.row.size)) +
                                  "\n                        "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Date", width: "150px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.formatDate(scope.row.time)) +
                                  "\n                        "
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "main-right" },
              _vm._l(_vm.tasks, function(task) {
                return _c("div", { key: task.id, staticClass: "task-item" }, [
                  _c(
                    "div",
                    { staticClass: "task-type" },
                    [
                      task.type == "tran"
                        ? _c("div", { staticClass: "cloudTransfer-black" })
                        : _vm._e(),
                      _vm._v(" "),
                      task.type == "sync"
                        ? _c("div", { staticClass: "cloudsync-black" })
                        : _vm._e(),
                      _vm._v(" "),
                      task.type == "backup"
                        ? _c("div", { staticClass: "cloudbackup-black" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-tooltip",
                        { attrs: { effect: "light", placement: "bottom" } },
                        [
                          _c("template", { slot: "content" }, [
                            _c("div", [
                              _vm._v(
                                "Create: " + _vm._s(_vm.formatDate(task.ctime))
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "Upadte: " + _vm._s(_vm.formatDate(task.ctime))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(task.name))])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "80px",
                        "margin-top": "50px",
                        "padding-bottom": "50px",
                        "border-bottom": "1px solid #d3dcf0"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "right",
                                "align-items": "center"
                              },
                              attrs: { span: 8 }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("div", {
                                    class:
                                      "drive-icon-" +
                                      _vm.getDrive(task.fdid).type,
                                    staticStyle: {
                                      width: "60px",
                                      height: "60px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _c(
                                            "el-breadcrumb",
                                            {
                                              staticClass: "folder-nav",
                                              attrs: { separator: "/" }
                                            },
                                            _vm._l(
                                              _vm.getNodeArr(task.param.from),
                                              function(node) {
                                                return _c(
                                                  "el-breadcrumb-item",
                                                  { key: node.id },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "folder-nav-span",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openFolder(
                                                              task.fdid,
                                                              node,
                                                              null
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(node.name)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "task-from-to",
                                          on: {
                                            click: function($event) {
                                              return _vm.openFolder(
                                                task.fdid,
                                                null,
                                                null
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getDrive(task.fdid).name)
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                                "align-items": "center"
                              },
                              attrs: { span: 8 }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("template", { slot: "content" }, [
                                    _c("div", [
                                      _vm._v(
                                        "List: " +
                                          _vm._s(
                                            task.param.options.threadCountList
                                          )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "Run: " +
                                          _vm._s(task.param.options.threadCount)
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "double_arrow",
                                    staticStyle: { "margin-top": "25px" }
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "left",
                                "align-items": "center"
                              },
                              attrs: { span: 8 }
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("div", {
                                    class:
                                      "drive-icon-" +
                                      _vm.getDrive(task.tdid).type,
                                    staticStyle: {
                                      width: "60px",
                                      height: "60px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "light",
                                        placement: "bottom"
                                      }
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _c(
                                            "el-breadcrumb",
                                            {
                                              staticClass: "folder-nav",
                                              attrs: { separator: "/" }
                                            },
                                            _vm._l(
                                              _vm.getNodeArr(task.param.to),
                                              function(node) {
                                                return _c(
                                                  "el-breadcrumb-item",
                                                  { key: node.id },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "folder-nav-span",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openFolder(
                                                              task.tdid,
                                                              node,
                                                              null
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(node.name)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "task-from-to",
                                          on: {
                                            click: function($event) {
                                              return _vm.openFolder(
                                                task.tdid,
                                                null,
                                                null
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getDrive(task.tdid).name)
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              {
                                staticClass: "task-status",
                                staticStyle: { "margin-top": "15px" }
                              },
                              [
                                task.status == "create"
                                  ? _c("i", {
                                      staticClass: "el-icon-circle-plus",
                                      staticStyle: { color: "skyblue" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "pending"
                                  ? _c("i", {
                                      staticClass: "el-icon-magic-stick",
                                      staticStyle: { color: "hotpink" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "running"
                                  ? _c("i", {
                                      staticClass: "el-icon-loading",
                                      staticStyle: { color: "gray" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "cancelled"
                                  ? _c("i", {
                                      staticClass: "el-icon-remove",
                                      staticStyle: { color: "gray" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "completed"
                                  ? _c("i", {
                                      staticClass: "el-icon-success",
                                      staticStyle: { color: "green" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "failed"
                                  ? _c("i", {
                                      staticClass: "el-icon-error",
                                      staticStyle: { color: "red" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "warn"
                                  ? _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: { color: "orange" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                task.status == "error"
                                  ? _c("i", {
                                      staticClass: "el-icon-s-release",
                                      staticStyle: { color: "red" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "light",
                                      placement: "bottom"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _c("span", [_vm._v(_vm._s(task.msg))])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.showTaskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c("b", [_vm._v(_vm._s(task.status))]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "task-line-info" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.taskLineInfo(task))
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "right",
                                  "margin-top": "10px"
                                }
                              },
                              [
                                !_vm.isRun(task.status)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary", plain: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.startTask(task.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-video-play"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Start")])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isRun(task.status)
                                  ? _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.cancelTask(task.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-close"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Cancel")])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isRun(task.status)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "danger", plain: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteTask(task.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Delete")])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              }),
              0
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "Add Cloud", visible: _vm.auth.show },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.auth, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.auth, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Type" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.auth.type,
                      callback: function($$v) {
                        _vm.$set(_vm.auth, "type", $$v)
                      },
                      expression: "auth.type"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "Name" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.auth.name,
                      callback: function($$v) {
                        _vm.$set(_vm.auth, "name", $$v)
                      },
                      expression: "auth.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.auth.type == "FTP"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Protocol" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Protocol" },
                              model: {
                                value: _vm.auth.ftp.protocol,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "protocol", $$v)
                                },
                                expression: "auth.ftp.protocol"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "ftp-plain",
                                  value: "ftp-plain"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "ftps-explicit",
                                  value: "ftps-explicit"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: {
                                  label: "ftps-implicit",
                                  value: "ftps-implicit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Host" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.ftp.host,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "host", $$v)
                              },
                              expression: "auth.ftp.host"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Port" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.ftp.port,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "port", $$v)
                              },
                              expression: "auth.ftp.port"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Username" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.ftp.username,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "username", $$v)
                              },
                              expression: "auth.ftp.username"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Password" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.ftp.password,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "password", $$v)
                              },
                              expression: "auth.ftp.password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Passive" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.auth.ftp.passive,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "passive", $$v)
                              },
                              expression: "auth.ftp.passive"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Encoding" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Encoding" },
                              model: {
                                value: _vm.auth.ftp.encoding,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "encoding", $$v)
                                },
                                expression: "auth.ftp.encoding"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "UTF-8", value: "UTF-8" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "GBK", value: "GBK" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Path" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.ftp.path,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.ftp, "path", $$v)
                              },
                              expression: "auth.ftp.path"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "SFTP"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Host" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.host,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "host", $$v)
                              },
                              expression: "auth.sftp.host"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Port" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.port,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "port", $$v)
                              },
                              expression: "auth.sftp.port"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Username" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.username,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "username", $$v)
                              },
                              expression: "auth.sftp.username"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Password" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.password,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "password", $$v)
                              },
                              expression: "auth.sftp.password"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Private Key" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.auth.sftp.privateKey,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "privateKey", $$v)
                              },
                              expression: "auth.sftp.privateKey"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Passphrase" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.passphrase,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "passphrase", $$v)
                              },
                              expression: "auth.sftp.passphrase"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Path" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.sftp.path,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.sftp, "path", $$v)
                              },
                              expression: "auth.sftp.path"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "WebDAV"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "URL" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.webdav.url,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.webdav, "url", $$v)
                              },
                              expression: "auth.webdav.url"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Username" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.webdav.username,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.webdav, "username", $$v)
                              },
                              expression: "auth.webdav.username"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Password" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.webdav.password,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.webdav, "password", $$v)
                              },
                              expression: "auth.webdav.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.auth.type == "MediaFire"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.mediafire.email,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.mediafire, "email", $$v)
                              },
                              expression: "auth.mediafire.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Password" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.auth.mediafire.password,
                              callback: function($$v) {
                                _vm.$set(_vm.auth.mediafire, "password", $$v)
                              },
                              expression: "auth.mediafire.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.auth.show = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.addCloud()
                    }
                  }
                },
                [_vm._v("Add")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "Cloud Info", visible: _vm.driveInfo.show },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.driveInfo, "show", $event)
            }
          }
        },
        [
          _vm.driveInfo.used
            ? _c("div", [
                _c("b", [_vm._v("Used:")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatBytes(_vm.driveInfo.used)))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.total
            ? _c("div", [
                _c("b", [_vm._v("Total:")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatBytes(_vm.driveInfo.total)))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.email
            ? _c("div", [
                _c("b", [_vm._v("Email:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.driveInfo.email))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.name
            ? _c("div", [
                _c("b", [_vm._v("Name:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.driveInfo.name))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.ftp.host
            ? _c("div", [
                _c("div", [
                  _c("b", [_vm._v("Protocol:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.protocol))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Host:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.host))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Port:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.port))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Username:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.username))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Passive:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.passive))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Encoding:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.encoding))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Path:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.ftp.path))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.sftp.host
            ? _c("div", [
                _c("div", [
                  _c("b", [_vm._v("Host:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.sftp.host))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Port:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.sftp.port))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Username:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.sftp.username))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Path:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.sftp.path))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.webdav.url
            ? _c("div", [
                _c("div", [
                  _c("b", [_vm._v("URL:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.webdav.url))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v("Username:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.webdav.username))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.driveInfo.mediafire.email
            ? _c("div", [
                _c("div", [
                  _c("b", [_vm._v("Email:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.driveInfo.mediafire.email))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.driveInfo.show = false
                    }
                  }
                },
                [_vm._v("Close")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.curTask
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showCurTask,
                title: "Task Details: " + _vm.curTask.name,
                width: "1000px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showCurTask = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "task-status",
                  staticStyle: {
                    "text-align": "center",
                    "font-size": "30px",
                    "font-weight": "bold"
                  }
                },
                [
                  _vm.curTask.status == "create"
                    ? _c("i", {
                        staticClass: "el-icon-circle-plus",
                        staticStyle: { color: "skyblue" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "pending"
                    ? _c("i", {
                        staticClass: "el-icon-magic-stick",
                        staticStyle: { color: "hotpink" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "running"
                    ? _c("i", {
                        staticClass: "el-icon-loading",
                        staticStyle: { color: "gray" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "cancelled"
                    ? _c("i", {
                        staticClass: "el-icon-remove",
                        staticStyle: { color: "gray" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "completed"
                    ? _c("i", {
                        staticClass: "el-icon-success",
                        staticStyle: { color: "green" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "failed"
                    ? _c("i", {
                        staticClass: "el-icon-error",
                        staticStyle: { color: "red" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "warn"
                    ? _c("i", {
                        staticClass: "el-icon-warning",
                        staticStyle: { color: "orange" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.curTask.status == "error"
                    ? _c("i", {
                        staticClass: "el-icon-s-release",
                        staticStyle: { color: "red" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "light", placement: "bottom" } },
                    [
                      _c("template", { slot: "content" }, [
                        _c("div", [
                          _c("span", [
                            _c("b", [_vm._v("Task Msg:")]),
                            _vm._v(" " + _vm._s(_vm.curTask.msg))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.curTask.result.curMsg
                          ? _c("div", [
                              _c("span", [
                                _c("b", [_vm._v("Cur Msg:")]),
                                _vm._v(" " + _vm._s(_vm.curTask.result.curMsg))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.curTask.result.curNode
                          ? _c("div", [
                              _c("div", [
                                _c("span", [
                                  _c("b", [_vm._v("Cur Node:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getNodePath(
                                          _vm.curTask.result.curNode
                                        )
                                      )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", [
                                  _c("b", [_vm._v("Cur Node Msg:")]),
                                  _vm._v(
                                    " " + _vm._s(_vm.curTask.result.curNode.msg)
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.curTask.status))])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { margin: "20px 0px" }, attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "right",
                        "align-items": "center"
                      },
                      attrs: { span: 9 }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.curTask.result.countSkip +
                                    _vm.curTask.result.countWarn +
                                    _vm.curTask.result.countError +
                                    _vm.curTask.result.countSuccess +
                                    " / " +
                                    _vm.curTask.result.countSum
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            { attrs: { effect: "light", placement: "bottom" } },
                            [
                              _c(
                                "template",
                                { slot: "content" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.countTitle(_vm.curTask.result))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.curTask.result.countSum
                                    ? _c("el-progress", {
                                        staticStyle: {
                                          "margin-bottom": "10px"
                                        },
                                        attrs: {
                                          "text-color": "white",
                                          "text-inside": true,
                                          "stroke-width": 20,
                                          percentage: parseFloat(
                                            (
                                              (_vm.countCur(
                                                _vm.curTask.result
                                              ) /
                                                _vm.curTask.result.countSum) *
                                              100
                                            ).toFixed(2)
                                          )
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b", [_vm._v("Count")])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center"
                      },
                      attrs: { span: 6 }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatBytes(_vm.curTask.result.sizeCur) +
                                    " / " +
                                    _vm.formatBytes(_vm.curTask.result.sizeSum)
                                ) + "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            { attrs: { effect: "light", placement: "bottom" } },
                            [
                              _c("template", { slot: "content" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "200px",
                                      "text-align": "center"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c("b", [_vm._v("Avg Speed: ")]),
                                      _vm._v(
                                        _vm._s(
                                          _vm.avgSpeed(
                                            _vm.curTask.result.startTime,
                                            _vm.curTask.result.endTime,
                                            _vm.curTask.result.sizeCur
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.curTask.result.sizeSum
                                      ? _c("el-progress", {
                                          attrs: {
                                            "text-color": "white",
                                            "text-inside": true,
                                            "stroke-width": 20,
                                            percentage: parseFloat(
                                              (
                                                (_vm.curTask.result.sizeCur /
                                                  _vm.curTask.result.sizeSum) *
                                                100
                                              ).toFixed(2)
                                            )
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("b", [_vm._v("Size")])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "left",
                        "align-items": "center"
                      },
                      attrs: { span: 9 }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "text-align": "center" } },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatTime(
                                    _vm.curTask.result.endTime -
                                      _vm.curTask.result.startTime
                                  )
                                ) + "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            { attrs: { effect: "light", placement: "bottom" } },
                            [
                              _c("template", { slot: "content" }, [
                                _c("div", [
                                  _vm.curTask.result.ttl
                                    ? _c("div", [
                                        _c("span", [
                                          _c("b", [_vm._v("TTL:")]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatTime(
                                                  _vm.curTask.result.ttl
                                                )
                                              )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("span", [
                                      _c("b", [_vm._v("Start:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.curTask.result.startTime
                                            )
                                          )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("span", [
                                      _c("b", [_vm._v("End:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.curTask.result.endTime
                                            )
                                          )
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("b", [_vm._v("Time")])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.curTask.status == "running"
                ? _c(
                    "el-table",
                    {
                      staticStyle: { "max-height": "530px", overflow: "auto" },
                      attrs: {
                        data: _vm.curTask.result.runningFiles,
                        border: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", width: "50" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Running Files",
                          "show-overflow-tooltip": "",
                          width: "680px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getNodePath(scope.row)))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1525508786
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Msg", "show-overflow-tooltip": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(scope.row.msg) +
                                      "\n                "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1429300836
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.curTask.errors
                ? _c(
                    "el-table",
                    {
                      staticStyle: { height: "400px", overflow: "auto" },
                      attrs: {
                        data: _vm.curTask.errors,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "Error Files",
                          "show-overflow-tooltip": "",
                          width: "400px"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.dir
                                    ? _c("i", { staticClass: "el-icon-folder" })
                                    : _c("i", {
                                        staticClass: "el-icon-document"
                                      }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getNodePath(scope.row)))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          132183544
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Size", width: "100px" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.formatBytes(scope.row.size)) +
                                      "\n                "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2848540995
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Warn", width: "60px" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(scope.row.warn) +
                                      "\n                "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          530979863
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Msg", "show-overflow-tooltip": "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(scope.row.msg) +
                                      "\n                "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1429300836
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "Trace", width: "70px" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "show-trace",
                                      on: {
                                        click: function($event) {
                                          _vm.traceInfo = scope.row.trace
                                        }
                                      }
                                    },
                                    [_vm._v("Show")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2402342458
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.traceInfo
                ? _c("pre", { staticClass: "trace-info" }, [
                    _vm._v(_vm._s(_vm.traceInfo))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.traceInfo
                ? _c(
                    "el-button",
                    {
                      staticClass: "trace-close",
                      on: {
                        click: function($event) {
                          _vm.traceInfo = null
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-close" })]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b64057", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b64057","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mc_lite.vue
// module id = null
// module chunks = 